export interface RefundNotice {
  id: string;
  amount_cents: number;
  currency: string;
  fully_refunded: boolean;
  created_at: string;
}

export function refundMoney(cents: number, currency: string): string {
  return new Intl.NumberFormat('en', { style: 'currency', currency: currency.toUpperCase() }).format(cents / 100);
}

/** "€17.00 refunded on 3 Nov 2026" (full refunds say so). */
export function refundLine(n: RefundNotice): string {
  const when = new Date(n.created_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' });
  return `${refundMoney(n.amount_cents, n.currency)} refunded${n.fully_refunded ? ' in full' : ''} on ${when}`;
}
